module.exports = __webpack_public_path__ + "img/btn_left.6064d773.png";